export default __webpack_public_path__ + "static/media/clamdestine.f8271514.png";